import {Alert, Button, FormHelperText, Stack, TextField} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {handleInputChange} from "src/components/form/formHandler";
import React, {useState} from "react";
import userInviteApi from "src/api/user/userInviteApi";
import {handleApiError} from "src/api/errorHandler";

const InviteSomeoneForm = () => {
  const [formValues, setFormValues] = useState({
    'name': '',
    'email': '',
  })
  const [formErrors, setFormErrors] = useState({});
  const [userInvited, setUserInvited] = useState('');

  const getDataFromForm = () => ({
    'name': formValues.name,
    'email': formValues.email,
  });

  const handleSubmit = async () => {
    const data = getDataFromForm();
    try {
      const userInvite = await userInviteApi.create(data);
      setUserInvited(userInvite.email);
    } catch (e) {
      handleApiError(e, setFormErrors);
    }
  }

  return (
    <Grid2 container spacing={2}>
      <Grid2 xs={12} sm={6}>
        <TextField
          value={formValues.name}
          name="name"
          label="Naam van uitgenodigde persoon"
          onChange={(e) => handleInputChange(e, formValues, setFormValues)}
          error={'name' in formErrors}
          helperText={formErrors.name}
          margin="dense"
          fullWidth
          required
        />
      </Grid2>

      <Grid2 xs={12} sm={6}>
        <TextField
          value={formValues.email}
          name="email"
          label="E-mail van uitgenodigde persoon"
          onChange={(e) => handleInputChange(e, formValues, setFormValues)}
          error={'email' in formErrors}
          helperText={formErrors.email}
          margin="dense"
          fullWidth
          required
        />
      </Grid2>

      { userInvited && (
        <Grid2 xs={12}>
          <Alert severity="success">
            Er is een uitnodiging verstuurd naar { userInvited }!
          </Alert>
        </Grid2>
      )}

      {formErrors['@general'] ? <Grid2 xs={12}><FormHelperText error>{formErrors['@general']}</FormHelperText></Grid2> : null}

      <Grid2 xs={12}>
        <Button
          onClick={handleSubmit}
          variant="contained"
          // Prevent double user invites
          disabled={userInvited === formValues.email}
        >
          Uitnodigen
        </Button>
      </Grid2>
    </Grid2>
  )
}

export default InviteSomeoneForm;